import { ContactProjectionStore } from './store'

export * from './store'
export * from './types'

export const contactStore = ContactProjectionStore.new()
export {
  ContactHttpStore,
  ContactProjectionStore,
} from './store'
